var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 21",
    style: {
      enableBackground: "new 0 0 20 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,15.1h-2.5v2.5h2.5V15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8,15.1h-2.5v2.5h2.5V15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,10.7h-2.5v2.5h2.5V10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8,10.7h-2.5v2.5h2.5V10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6,15.1H2.5V6.3h15v3.1h1.2V6.3c0-0.3-0.1-0.7-0.4-0.9C18.1,5.2,17.8,5,17.5,5h-3.8V2.5 c0-0.3-0.1-0.7-0.4-0.9c-0.2-0.2-0.6-0.4-0.9-0.4h-5c-0.3,0-0.6,0.1-0.9,0.4C6.4,1.9,6.3,2.2,6.2,2.5V5H2.5C2.2,5,1.9,5.2,1.6,5.4 C1.4,5.6,1.3,6,1.2,6.3v8.8c0,0.3,0.1,0.7,0.4,0.9c0.2,0.2,0.6,0.4,0.9,0.4h8.1V15.1z M7.5,2.5h5V5h-5V2.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryManagement);
export default __webpack_public_path__ + "static/media/inventory-management.a7caf01088b299d99d346b28d77fe2c4.svg";
export { ForwardRef as ReactComponent };